app.SiteDetailsView = app.BaseDetailsView.extend({
  // If countryCode is changed, force reload the timezone field view so it get a new list of
  // possible time zones for that country.
  _updateTimezoneSelection() {
    const fieldViews = this.fieldGroupView.fieldViewsByField;
    fieldViews.timezone.setValue(fieldViews.timezone.getValue(), fieldViews.timezone.model);
  },

  __fieldGroupDidChangeValue() {
    app.BaseDetailsView.prototype.__fieldGroupDidChangeValue.apply(this, arguments);

    this._updateTimezoneSelection();
  },

  _getTabId() {
    return Object.values(this.getSchema().fields)[0].tabId;
  },

  _renderCustomTemplates() {
    if (!app.sessionUser.isBite() || this._getTabId() !== 'site-settings') {
      return;
    }

    const $displayGroup = $('<div class="field-group"></div>');
    $displayGroup.append(
      this.valueDisplayTemplate({
        label: 'Site ID:',
        value: this.model.id,
      }),
    );
    $displayGroup.append(
      this.valueDisplayTemplate({
        label: 'Org ID:',
        // The site schema has no orgId field, and every site page loads its org.
        value: app.org.id,
      }),
    );
    this.$el.append($displayGroup);
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    this._renderCustomTemplates();

    return this;
  },
});
